<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>De beste verhuistips</h1>
      <p>De beste verhuistips vindt u natuurlijk op Alleverhuizers.nl!</p>

      <h2>Algemeen</h2>
      <ul>
        <li>
          Als u zich laat verhuizen:
          <nuxt-link to="/">
            vraag offertes aan via Alleverhuizers.nl.
          </nuxt-link>
          Vergelijk de offertes.
        </li>
        <li>
          Regel als u zelf verhuist verhuisdozen. Zorg voor speciale dozen of
          materialen voor kwetsbare apparatuur als computer en stereo.
        </li>
        <li>
          Zorg ervoor dat de telefoonaansluiting op uw nieuwe adres al geregeld
          is op de dag van de verhuizing.
        </li>
        <li>
          Bestel de gemeentegids van uw nieuwe woonplaats indien van toepassing
        </li>
        <li>
          Informeer naar verhuisvergoedingen/subsidies bij uw werkgever en
          mogelijke belastingaftrek van de verhuiskosten.
        </li>
        <li>Regel eventuele overnamekosten.</li>
        <li>
          Houd rekening met levertijden. Als u spullen voor het nieuwe huis
          koopt.
        </li>
        <li>
          Roep tijdig de hulp van een vakman in voor eventuele verbouwingen die
          u zelf niet kunt of wilt uitvoeren. Kijk hiervoor op:
        </li>
        <li>
          Verhuizing doorgeven aan uw verzekeringsmaatschappij(en) voor het
          aanpassen van polissen.
        </li>
        <li>
          Geef uw nieuwe adres door aan PostNL en regel dat uw post een tijdje
          wordt doorgestuurd.
        </li>
        <li>
          Informeer bij het energiebedrijf naar af- en aansluitingen van gas,
          licht en water.
        </li>
        <li>Geef uw verhuizing door aan alle instanties waar dit nodig is</li>
        <li>
          Begin vast met het inpakken van spullen die u nu en in het nieuwe huis
          niet direct nodig heeft.
        </li>
      </ul>

      <h2>Het nieuwe huis. Regel voor uw verhuizing:</h2>
      <ul>
        <li>Een grote schoonmaak van uw nieuwe huis.</li>
        <li>
          Vervang de sloten. Controleer of het nieuwe huis afdoende is beveiligd
          tegen inbraak.
        </li>
        <li>Pak alles in wat u komende dagen niet meer nodig hebt.</li>
        <li>Eventueel oude vloerbedekking verwijderen.</li>
        <li>
          Pak serviesgoed, bestek en glaswerk in, maar houd het hoogst
          noodzakelijke bij de hand.
        </li>
        <li>Laat extra sleutels bijmaken van uw nieuwe woning.</li>
        <li>
          Trommelbeveiliging wasautomaat en drogervast zetten, evenals de harde
          schijf van de computer.
        </li>
        <li>
          Stroom van de koelkast afsluiten, laten ontdooien en schoonmaken.
        </li>
        <li>Demontabele meubels uit elkaar halen. Markeer de onderdelen!</li>
        <li>Laatste spulletjes inpakken.</li>
      </ul>

      <h2>Dag van verhuizing:</h2>
      <ul>
        <li>
          Gas en elektra in de oude woning afsluiten en de meterstanden opnemen.
        </li>
        <li>Alles zoveel mogelijk op de juiste plaats (laten) zetten</li>
        <li>Pas na 24 uur de stroom voor koelkast en vrieskist aansluiten.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Verhuistips: de beste vind je natuurlijk op Alleverhuizers.nl!',
      headDescription:
        'Ben je op zoek naar verhuistips om zo goedkoop, snel en veilig mogelijk te verhuizen? Hier kun je terecht voor gratis tips én offertes!',
    }
  },
}
</script>
